/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class OneDefaultTranslationsService {
  defaultTranslations: any;

  constructor(private translateService: TranslateService) {}

  loadDefaultTranslations(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.translateService.getTranslation('en').subscribe((data) => {
        this.defaultTranslations = data;
        resolve();
      });
    });
  }
}
